export default {
  API_URL: "https://crmcsg.kz/",
  API_HOST: "https://crmcsg.kz/static/",
};
// export default {
//   API_URL: "http://localhost:3000/",
//   API_HOST: "http://localhost:3000/",
// };
